module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cn/cards_116-f3.6bb0f71a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cn/cards_116-f3.png
// module id = 1061
// module chunks = 16